var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconTask48Line = function SvgIconTask48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.37 11.3H31.7v-.1a2.9 2.9 0 0 0-2.9-2.9h-9.6a2.9 2.9 0 0 0-2.9 2.9v.1h-1.7a5.3 5.3 0 0 0-5.3 5.3v17.8a5.31 5.31 0 0 0 5.3 5.3h18.8a5.31 5.31 0 0 0 5.3-5.3V16.6a5.3 5.3 0 0 0-5.33-5.3Zm-13.7.4h8.6v2.6H19.7l-.03-2.6Zm15.6 22.7a1.9 1.9 0 0 1-1.9 1.9h-18.8a1.9 1.9 0 0 1-1.9-1.9V16.6a1.9 1.9 0 0 1 1.9-1.9h1.7v.1a2.9 2.9 0 0 0 2.9 2.9h9.6a2.9 2.9 0 0 0 2.9-2.9v-.1h1.7a1.9 1.9 0 0 1 1.9 1.9v17.8Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m22.232 27.171-3-3.22-2.48 2.32 3.36 3.59a2.86 2.86 0 0 0 2.07.92 2.88 2.88 0 0 0 2-.83l6.92-6.83-2.39-2.42-6.48 6.47Z",
    fill: "current"
  })));
};
export default SvgIconTask48Line;